(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stav-creators-current"] && !Shopify.designMode) return;
  try {
    (function () {
    function initializeCreatorCarousels() {
      document.querySelectorAll('.stav-creators__grid:not([data-stav-marquee-ready])').forEach(function (track) {
        var cards = Array.from(track.querySelectorAll('.stav-creators__card'));
        if (cards.length < 2) return;
        cards.forEach(function (card) {
          var copy = card.cloneNode(true);
          copy.classList.add('is-marquee-copy');
          copy.setAttribute('aria-hidden', 'true');
          copy.setAttribute('tabindex', '-1');
          copy.querySelectorAll('[id]').forEach(function (element) { element.removeAttribute('id'); });
          copy.querySelectorAll('img').forEach(function (img) { img.alt = ''; });
          track.appendChild(copy);
        });
        track.parentElement.classList.add('is-marquee');
        track.dataset.stavMarqueeReady = 'true';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCreatorCarousels);
    } else {
      initializeCreatorCarousels();
    }
    document.addEventListener('shopify:section:load', initializeCreatorCarousels);
  }());
  } catch(e) { console.error(e); }
})();

})();
